import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'
import theme from 'ui/styles/theme'

import IconPlus from 'ui/components/generic/IconPlus'
import IconSmallPlus from 'ui/components/generic/IconSmallPlus'

const Image = styled.img`
  display: block;
  width: 100%;
`

const HighlightContainer = styled.div`
  position: absolute;
  left: ${props => props.posX}%;
  top: ${props => props.posY}%;
  transform: ${props => props.active ? 'translateX(-50%) translateY(-50%) scale(0.75)' : 'translateX(-50%) translateY(-50%)'};
  width: ${props => props.size === 'large' ? '250px' : '125px'};
  height: ${props => props.size === 'large' ? '250px' : '125px'};
  transition: transform 0.3s ${easing.easeOutCubic}, opacity 0.3s ${easing.easeOutCubic};
  opacity: ${props => props.active ? 0 : 1};
  z-index: 1;
`

const HighlightInner = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 75%;
  height: 75%;
  background: pink;
  z-index: 1;
  border-radius: 100%;
  background: ${theme.colors.highlight};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ${easing.easeOutCubic}, opacity 0.3s ${easing.easeOutCubic};

  &:hover {
    transform: translateX(-50%) translateY(-50%) rotate(90deg);
    cursor: pointer;
  }
`

const pulse = keyframes`
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(-50%) scale(0.75);
  }

  35% {
    opacity: 1;
    transform: translateX(-50%) translateY(-50%) scale(0.75);
  }
  
  85% {
    opacity: 1;
    transform: translateX(-50%) translateY(-50%) scale(1);
  }

  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-50%) scale(1.1);
  }
`

const HighlightOuter = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  height: 100%;
  border-radius: 100%;
  animation: ${pulse} 4s ${easing.easeOutCubic} infinite;
  background: ${theme.colors.highlight};
`

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 20px;
  background: ${theme.colors.tones.lighter};
  width: 41.5%;
  padding: 30px;
  opacity: ${props => props.active ? 1 : 0};
  transform: ${props => props.active ? 'translateY(0)' : 'translateY(-30px)'};
  transition: opacity 0.3s ${easing.easeOutCubic}, transform 0.3s ${easing.easeOutCubic};
`

const Heading = styled.h4`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  border-top: 1px solid ${theme.colors.tones.dark};
  padding-top: 30px;
`

const Text = styled.p`
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
`

const Close = styled.div`
  width: 47px;
  height: 47px;
  position: absolute;
  top: 0;
  right: 0;
  background: ${theme.colors.highlight};
  border-radius: 100%;
  transform: translateX(50%) translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ${easing.easeOutCubic};

  &:hover {
    transform: translateX(50%) translateY(-50%) scale(1.15);
  }
`

export default class Highlight extends Component {
  state = {
    active: false
  }

  render() {
    const {
      highlightSize,
      image,
      posX,
      posY,
      heading,
      text
    } = this.props

    const { active } = this.state

    return(
      <Container fluid>
        <Row>
          <Col
            sm={9}
            smOffset={3}
          >
            <HighlightContainer
              posX={posX}
              posY={posY}
              size={highlightSize}
              active={active}
            >
              <HighlightInner onClick={() => this.setState({active: true})}>
                <IconPlus />
              </HighlightInner>
              <HighlightOuter />
            </HighlightContainer>
            <Overlay active={active}>
              <Close onClick={() => this.setState({active: false})}>
                <IconSmallPlus />
              </Close>
              <Heading>{heading}</Heading>
              <Text>{text}</Text>
            </Overlay>
            <Image src={image.sourceUrl} />
          </Col>
        </Row>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Highlight/index.js